import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Injector } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { tap, timeout, finalize, catchError } from 'rxjs/operators';
import { AppInsightsService } from '../appInsight.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class MonitoringInterceptor implements HttpInterceptor {
    constructor(private inj: Injector) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const monitoringService = this.inj.get(AppInsightsService);
        const startTime = Date.now();
        const timeoutValue = Number(req.headers.get('timeout')) || 60000;
        const bodyRequest = req.body;
        const started = Date.now();

        return next.handle(req).pipe(
            timeout(timeoutValue),
            tap((eventResponse: any) => {
                if (eventResponse instanceof HttpResponse) {
                    const elapsed = Date.now() - started;
                    monitoringService.logAjax(
                        req.method, // method
                        req.urlWithParams, // url
                        req.url, // name
                        elapsed, // totaltime
                        eventResponse.ok, // success
                        eventResponse.status, // resultcode,
                        req.body,
                        eventResponse.body
                    );
                }
            }),
            catchError((error: HttpErrorResponse) => {
                const elapsed = Date.now() - started;
                if (error.status !== 401) {
                    monitoringService.logAjax(
                        req.method, // method
                        req.urlWithParams, // url
                        req.url, // name
                        elapsed, // totaltime
                        error.ok, // success
                        error.status, // resultcode,
                        req.body
                    );
                }
                return throwError(error);
            })
        );
    }
}
